/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, March 2022
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import PaperTile from '../../../components/PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';
import { getDistrictForUser, replaceMultipleSpaces } from '../../../lib/utils';
import { fetchDistrictServices } from '../../../actions/district';
import { adminEndpoint, adminRole } from '../../../config';
import { DecisionContainer } from '../../../containers';
import v from '../../eservices/validators';
import ModalAlert from '../../eservices/ModalAlert';
import styles from './DistrictDeclarations.css';
import { PanelStyle } from '../../../constants';
import SimpleTextEditor from '../../../components/utils/SimpleTextEditor/SimpleTextEditor';

import GrayPanel from '../../../components/GrayPanel/GrayPanel';
import { TEMPLATE_DECLARATION, CUSTOM_DECLARATION, CUSTOM_HTML_DECLARATION } from '../../eservices/constants';


const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  width: '100%',
};

const btnStyle2 = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const districtDict = {
  createdAt: {
    label: 'Data utworzenia deklaracji',
    editable: true,
  },
  personName: {
    label: 'Osoba do kontaktu - imię i nazwisko',
    editable: true,
  },
  personEmail: {
    label: 'Osoba do kontaktu - email',
    editable: true,
  },
  personPhone: {
    label: 'Osoba do kontaktu - telefon',
    editable: true,
  },
  descriptionLink: {
    label: 'Link do opisu dostępności architektonicznej*',
    editable: true,
  },
  translatorLink: {
    label: 'Link do opisu dostępności tłumacza języka migowego**',
    editable: true,
  },
  translatorDescription: {
    label: 'Opis dostępności tłumacza języka migowego***',
    editable: true,
    type: 'textarea',
  },
};

const typeOptions = [
  {
    label: 'Według wzoru GIAP',
    value: TEMPLATE_DECLARATION,
    state: 'declarationType',
  },
  {
    label: 'Własny tekst',
    value: CUSTOM_DECLARATION,
    state: 'declarationType',
  },
    {
    label: 'Własny HTML',
    value: CUSTOM_HTML_DECLARATION,
    state: 'declarationType',
  },
];

const typeDict = {
  declarationType: {
    label: 'Rodzaj deklaracji',
    editable: true,
    type: 'Select',
    options: typeOptions,
  },
}

const textEditorModules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ 'align': [] }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    ['link'],
    ['clean']
  ]
};

const emptyDistrictData = {
  createdAt: '',
  personName: '',
  personEmail: '',
  personPhone: '',
  descriptionLink: '',
  translatorLink: '',
  translatorDescription: '',
};

const emptyArchitecturalAvailability = [
  {
    description: '',
  },
];


class DistrictDeclarations extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    districts: PropTypes.object,
  };

  state = {
    selected_district: null,
    filter_text: '',
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    showModal: false,
    districtData: emptyDistrictData,
    architecturalAvailability: emptyArchitecturalAvailability,
    defaultDistrictData: emptyDistrictData,
    defaultArchitecturalAvailability: emptyArchitecturalAvailability,
    dataLoaded: false,

    info: {
      declarationType: TEMPLATE_DECLARATION,
    },

    defaultDeclarationType: TEMPLATE_DECLARATION,

    textEditorContent: '',
    defaultTextEditorContent: '',
    textEditorDataChanged: false,

    htmlContent: '',
    defaultHtmlContent: '',
    htmlDataChanged: false,
  };

  validators = {
    createdAt: [v.NotNull, v.CheckDate],
    personName: [v.NotNull],
    personEmail: [v.NotNull, v.CheckEmail],
    personPhone: [v.NotNull],
    description: [v.NotNull],
  };

  componentDidMount = () => {
    this.fetchDistrict();
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  async fetchDistrict() {
    if (this.props.isDistrictAdmin) {
      const selectedDistrict = await getDistrictForUser(this.props.user.ID);
      this.setState({ selected_district: selectedDistrict }, () => this.fetchDistrictData());
    } else {
      this.setState({ selected_district: null });
    }
  }

  async fetchDistrictData(hideAlert = false) {
    const url = `${process.env.API_URL}/eservices/declaration_of_availability/${this.state.selected_district}`;
    fetch(url, {
      method: 'GET',
    }).then(r => {
      if (r.ok) {
        return r.json();
      } else {
        throw new Error('Błąd przy pobieraniu danych deklaracji dostępności.');
      }
    })
      .then(response => {

        const resp = response.data;

        const declarationType = resp.declaration_type ? resp.declaration_type : TEMPLATE_DECLARATION;

        if (declarationType === CUSTOM_DECLARATION) {

          return this.setState({
            info: { declarationType },
            defaultDeclarationType: declarationType,
            textEditorContent: resp.declaration_content,
            defaultTextEditorContent: resp.declaration_content,
            htmlContent: '',
            defaultHtmlContent: '',
            districtData: emptyDistrictData,
            architecturalAvailability: emptyArchitecturalAvailability,
            defaultDistrictData: emptyDistrictData,
            defaultArchitecturalAvailability: emptyArchitecturalAvailability,
            dataLoaded: true,
          }, () => { hideAlert ? this.showModalAlert() : null; });

        }

        if (declarationType === CUSTOM_HTML_DECLARATION) {

          return this.setState({
            info: { declarationType },
            defaultDeclarationType: declarationType,
            htmlContent: resp.declaration_content,
            defaultHtmlContent: resp.declaration_content,
            textEditorContent: '',
            defaultTextEditorContent: '',
            districtData: emptyDistrictData,
            architecturalAvailability: emptyArchitecturalAvailability,
            defaultDistrictData: emptyDistrictData,
            defaultArchitecturalAvailability: emptyArchitecturalAvailability,
            dataLoaded: true,
          }, () => { hideAlert ? this.showModalAlert() : null; });

        }

        else {

          const districtData = this.state.districtData;
          districtData.createdAt = resp.createdAt;
          districtData.personName = resp.person_name;
          districtData.personEmail = resp.person_email;
          districtData.personPhone = resp.person_phone_number;
          districtData.descriptionLink = resp.description_link;
          districtData.translatorLink = resp.translator_link;

          const architecturalAvailability = []
          let translatorDescription = false;

          for (const desc of resp.desc_list) {
            if (desc.is_translator_description) {
              translatorDescription = true;
              districtData.translatorDescription = desc.description;
            } else {
              architecturalAvailability.push({
                description: desc.description,
              });
            }
          }

          if (! translatorDescription) {
            districtData.translatorDescription = '';
          }

          return this.setState({
            dataLoaded: true,
            districtData,
            architecturalAvailability,
            defaultDistrictData: districtData,
            defaultArchitecturalAvailability: architecturalAvailability,
            info: { declarationType },
            defaultDeclarationType: declarationType,
            htmlContent: '',
            defaultHtmlContent: '',
            textEditorContent: '',
            defaultTextEditorContent: '',
          }, () => { hideAlert ? this.showModalAlert() : null; });

        }
      })
      .catch((e) => {
        return this.setState({
          errorText: 'Wystąpił błąd przy pobieraniu danych deklaracji dostępności.',
          errorTitle: 'Błąd przy pobieraniu danych.',
          showError: true,
          dataLoaded: false,
        });

      });

  }

  cancelChanges = () => {
    if (this.state.info.declarationType === CUSTOM_DECLARATION) {
      return this.setState({
        textEditorContent: this.state.defaultTextEditorContent,
        textEditorDataChanged: false,
        info: { declarationType: this.state.defaultDeclarationType },
      });
    }

    if (this.state.info.declarationType === CUSTOM_HTML_DECLARATION) {
      return this.setState({
        htmlContent: this.state.defaultHtmlContent,
        htmlDataChanged: false,
        info: { declarationType: this.state.defaultDeclarationType },
      });
    }

    if (this.state.info.declarationType === TEMPLATE_DECLARATION) {
      this.setState({
        districtData: this.state.defaultDistrictData,
        architecturalAvailability: this.state.defaultArchitecturalAvailability,
        info: { declarationType: this.state.defaultDeclarationType },
      });
    }
  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;

    this.setState(
      (prevState) => ({
        [group]: {
          ...prevState[group],
          [name]: e.value,
          
        },
        textEditorContent: this.state.defaultTextEditorContent,
        textEditorDataChanged: false,
        htmlContent: this.state.defaultHtmlContent,
        htmlDataChanged: false,
        districtData: this.state.defaultDistrictData,
        architecturalAvailability: this.state.defaultArchitecturalAvailability,
      }),
      () => this.validate(group, name)
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ["districtData", "info"];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  districtFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  onClick = (item) => {
    const prefix = this.props.districts[item].prefix;
    this.setState({ selected_district: prefix }, () => this.fetchDistrictData());
  };

  addPosition = () => {
    this.setState({
      architecturalAvailability: [...this.state.architecturalAvailability, {
        description: '',
      }],
    }, () => this.validatePositions());
  }

  removePosition = (i, state) => {
    const list = [...this.state[state]];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      [state]: list,
    });
  }

  onChangePosition = (e, state, elem, index) => {
    const arr = this.state[state];
    arr[index][elem] = e.target.value;

    this.setState({
      [state]: arr,
    }, () => this.validatePositions(state, elem, index),
    );
  }

  validatePositions = (group = null, field = null, index = null) => {
    let newState = null;
    if (field) {
      const checks = this.validatePositionField(group, field, index);
      newState = {
          ...this.state.errors,
          [`${field}${index}`]: checks,
      };
    } else {
      let errors = {};
      const grupy = ['architecturalAvailability'];
      for (const g of grupy) {
        const err = this.validateListGroups(g);
        errors = { ...errors, ...err };
      }
      newState = { ...this.state.errors, ...errors };
    }

    if (newState) {
      this.setState({ errors: newState });
    }
  };

  validatePositionField = (group, field, index) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][index][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateListGroups = (group) => {
    const errors = {};
    let idx = 0;
    if (this.state[group]) {
      for (const obj of this.state[group]) {
        for (const i in Object.keys(obj)) {
          const field = Object.keys(obj)[i];
          const checks = this.validatePositionField(group, field, idx);
          errors[`${field}${idx}`] = checks;
        }
        idx += 1;
      }
    }
    return errors;
  };

  getInputWithError = (group, field, idx, value, placeholder) => (
    <div style={{ textAlign: 'justify' }}>
      <input
        type="text"
        className="form-control"
        name={field}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.errors).indexOf(`${field}${idx}`) > -1 &&
              this.state.errors[`${field}${idx}`] !== null &&
              this.state.errors[`${field}${idx}`].length > 0
              ? 'red'
              : '#ccc',
        }}
        value={value}
        placeholder={placeholder}
        onChange={(e) => this.onChangePosition(e, group, field, idx)}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.errors).indexOf(`${field}${idx}`) > -1 &&
        this.state.errors[`${field}${idx}`] !== null &&
        this.state.errors[`${field}${idx}`].length > 0
        ? this.state.errors[`${field}${idx}`].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  showModalAlert = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  onHide = () => this.setState({ showError: false });

  // modal z potwierdzeniem lub odrzuceniem zmian
  confirmModal = () => {
    return (
      <div className={styles.declarationModal}>
        <div className={styles.declarationModal__container} style={this.state.style}>
          <div className={styles.declarationModal__header}>Czy na pewno chcesz zapisać zmiany?</div>
          <div className={styles.modalButtons}>
            <button onClick={this.showModalAlert} className="btn btn-warning">Anuluj</button>
            <button onClick={this.sendNewCardData} className={`btn btn-success ${styles.modalButtons__right}`}>Zapisz</button>
          </div>
        </div>
      </div>

    );
  }

  validateHtmlContent = (html) => {
    const VOID_TAGS = new Set([
      "br", "hr", "img", "input", "meta", "link"
    ]);

    const tagRegex = /<\/?([a-zA-Z0-9-]+)(\s[^>]*)?>/g;

    if (!tagRegex.test(html)) {
      return {
        valid: false,
        error: "Treść nie zawiera żadnych znaczników HTML"
      };
    }

    tagRegex.lastIndex = 0;

    const stack = [];
    let match;

    while ((match = tagRegex.exec(html)) !== null) {
      const fullTag = match[0];
      const tagName = match[1].toLowerCase();

      const isClosing = fullTag.startsWith("</");
      const isSelfClosing = fullTag.endsWith("/>") || VOID_TAGS.has(tagName);

      if (!isClosing && !isSelfClosing) {
        stack.push(tagName);
      }

      if (isClosing) {
        const last = stack.pop();

        if (!last) {
          return {
            valid: false,
            error: `Nadmiarowe zamknięcie: </${tagName}>`
          };
        }

        if (last !== tagName) {
          return {
            valid: false,
            error: `Błędne domknięcie: </${tagName}> zamiast </${last}>`
          };
        }
      }
    }

    if (stack.length > 0) {
      return {
        valid: false,
        error: `Brak domknięcia tagu: <${stack[stack.length - 1]}>`
      };
    }

    return { valid: true };
  };

  sendNewCardData = () => {
    let data = {
      declarationType: this.state.info.declarationType,
    };

    if (this.state.info.declarationType === TEMPLATE_DECLARATION) {

      data['districtData'] = this.state.districtData;
      data['architecturalAvailability'] = this.state.architecturalAvailability;

    } else if (this.state.info.declarationType === CUSTOM_DECLARATION) {

      data['textEditorContent'] = this.state.textEditorContent;

    } else if (this.state.info.declarationType === CUSTOM_HTML_DECLARATION) {

      data['htmlContent'] = this.state.htmlContent;

    }
  
    const successMessage = 'Zmiany zostały zapisane.';
    const failureMessage = 'Wystąpił błąd przy zapisie zmian.';
    fetch(`${process.env.API_URL}/eservices/district_declaration/save/${this.state.selected_district}`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
    ).then((response) => {
      if (response.status === 200) {
        this.setState({
          errorText: successMessage,
          errorTitle: 'Zmiany zapisane.',
          showError: true,
        }, () => this.fetchDistrictData(true));
      } else {
        this.setState({
          errorText: failureMessage,
          errorTitle: 'Błąd przy zapisywaniu zmian.',
          showError: true,
        });
      }
    });
  }

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  async postValidation () {

    if (this.state.info.declarationType === TEMPLATE_DECLARATION) {
      await this.validatePositions();
      const hasFieldErrors = this.haseErrors();

      if (hasFieldErrors) {
        this.setState({
          errorText: 'Uzupełnij pola obowiązkowe.',
          errorTitle: 'Błędnie wypełniony formularz.',
          showError: true,
        });
        return;
      }

      if (this.state.architecturalAvailability.length === 0 && !this.state.districtData.descriptionLink) {
        this.setState({
          errorText: 'Brak opisu dostępności architektonicznej. Wprowadź link lub opis.',
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
        });
        return;
      }

      if (this.state.architecturalAvailability.length > 0 && this.state.districtData.descriptionLink) {
        this.setState({
          errorText: 'Wprowadzono opis dostępności architektonicznej oraz link do opisu. Wprowadź tylko link lub opis.',
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
        });
        return;
      }

      if (!this.state.districtData.translatorLink && !this.state.districtData.translatorDescription) {
        this.setState({
          errorText: 'Brak opisu dostępności tłumacza języka migowego. Wprowadź link lub opis.',
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
        });
        return;
      }

      if (this.state.districtData.translatorLink && this.state.districtData.translatorDescription) {
        this.setState({
          errorText: 'Wprowadzono opis dostępności tłumacza języka migowego oraz link do opisu. Wprowadź tylko link lub opis.',
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
        });
        return;
      }

      if (!hasFieldErrors) {
        this.showModalAlert();
      }
    }

    if (this.state.info.declarationType === CUSTOM_DECLARATION) {
      if (this.state.textEditorContent === '' || this.state.textEditorContent === '<p><br></p>') {
        this.setState({
          errorText: 'Zawartość deklaracji nie może być pusta.',
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
        });
        return;
      }

      this.showModalAlert();
    }

    if (this.state.info.declarationType === CUSTOM_HTML_DECLARATION) {
      if (this.state.htmlContent === '') {
        this.setState({
          errorText: 'Zawartość deklaracji nie może być pusta.',
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
        });
        return;
      }

      const check = this.validateHtmlContent(this.state.htmlContent);

      if(!check.valid) {
        this.setState({
          errorText: `Niepoprawna zawartość HTML: ${check.error}`,
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
        });
        return;
      }

      this.showModalAlert();
    }
  };

  cancelTextEditorChanges = () => {
    this.ignoreNextEditorChange = true;
    this.setState({
        textEditorContent: this.state.defaultTextEditorContent,
        textEditorDataChanged: false,
    });
  }

  handleTextEditorChange = (html) => {
    if (this.ignoreNextEditorChange) {
        return this.ignoreNextEditorChange = false;
    }

    this.setState({
        textEditorContent: html,
        textEditorDataChanged: html !== this.state.defaultTextEditorContent,
    });
  };

  handleHtmlEditorChange = (e) => {
    const name = e.target.name;
    const html = e.target.value;

    this.setState({
        htmlContent: html,
        htmlDataChanged: html !== this.state.defaultHtmlContent,
    });
  };

  renderTemplatedDeclaration = () => {
    return (
      <DecisionContainer
        title={'Deklaracja dostępności'}
        data={this.state.districtData}
        errors={this.state.errors}
        formDict={districtDict}
        onChange={e => this.onChange(e, 'districtData')}
      >

        <div className="row" style={{ marginTop: '40px' }}>
          <div className="col-sm-8">
            <b>Opis dostępności architektonicznej****</b>
          </div>
          <div className="col-sm-4">
            <button
              type="submit-lg"
              className={'btn btn-primary'}
              style={{ float: 'right', ...btnStyle }}
              onClick={() => this.addPosition()}
            >
              Dodaj pozycję do opisu
          </button>
          </div>
        </div>

        <table className="table">
          <thead>
            <tr>
              <th scope="col">LP</th>
              <th scope="col">Opis</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.state.architecturalAvailability.map((v, i) => {
              return (
                <tr key={i}>
                  <td><p>{i + 1}</p></td>
                  <td style={{ width: '100%' }}>
                    {this.getInputWithError('architecturalAvailability', 'description', i, v.description, 'Opis...')}
                  </td>
                  <td>
                    <button
                      type="submit-lg"
                      className={'btn btn-danger'}
                      onClick={() => this.removePosition(i, 'architecturalAvailability')}
                    >
                      Usuń
                    </button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <div>
          <p><b>*</b> obowiązkowe w przypadku braku podania opisu dostępności architektonicznej,</p>
          <p><b>**</b> obowiązkowe w przypadku braku podania opisu dostępności tłumacza języka migowego,</p>
          <p><b>***</b> obowiązkowe w przypadku braku podania linku do opisu dostępności tłumacza języka migowego,</p>
          <p><b>****</b> obowiązkowe w przypadku braku podania linku do opisu dostępności architektonicznej,</p>
        </div>
      </ DecisionContainer>
    );
  }

  renderTextEditorDeclaration = () => {
    return (
      <GrayPanel
        title={'Edytor tekstu deklaracji dostępności'}
      >
        <SimpleTextEditor
          value={this.state.textEditorContent}
          onChange={this.handleTextEditorChange}
          modules={textEditorModules}
        />
      </GrayPanel>
    );
  }

  renderHtmlEditorDeclaration = () => {
    return (
      <GrayPanel
        title={'Edytor HTML deklaracji dostępności'}
      >
        <textarea
          name="htmlContent"
          value={this.state.htmlContent}
          onChange={this.handleHtmlEditorChange}
          rows={25}
          style={{ width: '100%' }}
        />
      </GrayPanel>
    );
  }
    

  renderDeclaration = () => {
    return (
      <div>
        <DecisionContainer
          title={'Rodzaj deklaracji'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={typeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        >

        </DecisionContainer>
        
        {this.state.info.declarationType === TEMPLATE_DECLARATION && this.renderTemplatedDeclaration()}
        {this.state.info.declarationType === CUSTOM_DECLARATION && this.renderTextEditorDeclaration()}
        {this.state.info.declarationType === CUSTOM_HTML_DECLARATION && this.renderHtmlEditorDeclaration()}

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-success disabled' : 'btn btn-success'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle2 }}
              onClick={() => this.startService()}
              disabled={!this.state.selected_district}
            >
              Zapisz zmiany
            </button>
            <button
              type="submit-lg"
              className="btn btn-primary"
              style={{ float: 'right', marginRight: '15px', ...btnStyle2}}
              onClick={() => this.cancelChanges()}
            >
              Anuluj zmiany
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <style>
          {`
            .btn disabled, .btn[disabled] {
              opacity: 1;
            }
          `}
        </style>
        {!this.props.isDistrictAdmin ?
          <div className={'well well-sm'} style={{ background: this.state.style.backgroundColor }}>
            <h4 style={{ textAlign: 'center', color: this.state.style.color }}>
              <b>Gminy:</b>
            </h4>
            <input
              type="text"
              className="form-control"
              style={{ width: '100%', position: 'relative', margin: '25px 0px 15px 0px' }}
              value={this.state.filter_text}
              placeholder="Wyszukaj urząd..."
              onChange={(e) => this.districtFilterChange(e)}
            />
            <ul className={'nav flex-column'} style={{ height: '400px', overflowY: 'scroll' }}>
              {this.props.districts && Object.keys(this.props.districts).sort()
                .filter(item => this.props.districts[item].name.toLowerCase().includes(this.state.filter_text.toLowerCase()))
                .map(item => (

                  <li className={'nav-item'} key={item}>
                    <button
                      type="button"
                      className={'btn btn-primary'}
                      style={btnStyle}
                      onClick={() => this.onClick(item)}
                    >
                      {this.props.districts[item].name}
                    </button>
                  </li>
                ))}
            </ul>
          </div> : null}
        {this.state.selected_district && this.state.dataLoaded ?
          <h4
            style={{ textAlign: 'center' }}
          >
            <b>{this.props.districts[this.state.selected_district].name}</b>
          </h4> : null}

        {this.state.selected_district && this.state.dataLoaded ?
        <PaperHeader title="Deklaracja dostępności" text="" /> : null}

        {this.state.selected_district && this.state.dataLoaded ? this.renderDeclaration() : 

          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3>Wybierz urząd, aby edytować deklarację dostępności.</h3>
          </div>
        }

        {this.state.showModal ? this.confirmModal() : null}
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts,
  eservices: state.district.eservices,
});

const mapDispatch = {
  fetchDistrictServices,
};

export default withStyles(styles)(connect(mapState, mapDispatch)(DistrictDeclarations));



// WEBPACK FOOTER //
// src/routes/admin/district_declarations/DistrictDeclarations.js